<div
  class="app-wrapper flex flex-col overflow-hidden lg:max-w-3xl lg:my-4 lg:mx-auto lg:rounded-lg lg:shadow-lg lg:h-[calc(100vh-2rem)]">
  @if (routeLoading()) {
    <div class="route-progress" aria-hidden="true"></div>
  }
  <div class="flex-1 overflow-auto contain-area">
    @if (maintenance$ | async; as maintenance) {
      <app-maintenance-view [title]="maintenance.title" [message]="maintenance.message"></app-maintenance-view>
    } @else {
      <router-outlet></router-outlet>
    }
  </div>
</div>
